import { Button } from "./design-system/button";
import { LoginCard } from "./login/LoginCard";
import { LoginCardInput } from "./login/LoginCardInput";
import { PROVIDER_PORTAL_MAIN_COLUMN_CLASS } from "./util/providerPortalMainColumn";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { rebrandEnabled } from "./util/brandingFlag";
import { useState } from "react";

/** Forgot-password form: requests a password reset email. */
export default function RequestPasswordReset() {
  const [email, setEmail] = useState("");

  const requestResetEmail = (email: string) => {
    fetch("/graphql/request-password-reset", {
      method: "POST",
      body: JSON.stringify({
        email: email,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    }).then((res) => {
      console.log(res);
      if (res.redirected) {
        window.location.href = res.url;
      }
    });
  };

  if (rebrandEnabled()) {
    return (
      <LoginCard heading="Forgot your password?">
        <form
          className="tw-flex tw-flex-col tw-gap-[24px]"
          onSubmit={(e) => {
            e.preventDefault();
            requestResetEmail(email);
          }}
        >
          <LoginCardInput
            id="reset-email"
            icon={faEnvelope}
            type="text"
            placeholder="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoFocus
          />
          <Button
            type="submit"
            colorScheme="tide"
            size="lg"
            className="tw-w-full"
          >
            Reset my password
          </Button>
        </form>
      </LoginCard>
    );
  }

  return (
    <div className={PROVIDER_PORTAL_MAIN_COLUMN_CLASS} id="login_row">
      <div className="tw-mx-auto tw-w-1/3 1040:tw-w-[90%]">
        <div className="panel panel-default tw-mt-[80px]">
          <div className="panel-heading">
            <h3 className="panel-title">Forgot Password?</h3>
          </div>
          <div id="existing-customer" className="panel-body">
            <div className="unobtrusive-flash-container"></div>
            <div>
              <div
                className="unobtrusive-flash-container"
                id="login-error"
              ></div>
              <fieldset id="password-credentials">
                <div className="tw-mb-[15px]">
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Email"
                    onChange={(e) => setEmail(e.target.value)}
                    value={email}
                  />
                </div>
                <div className="tw-mb-[15px]">
                  <button
                    className="btn btn-lg btn-success btn-block"
                    type="submit"
                    onClick={() => requestResetEmail(email)}
                  >
                    Reset my password
                  </button>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
